import { useEvent } from 'react-use';

export const useRefetchOnVisible = (refetch: () => void, enabled = true) => {
  useEvent(
    'visibilitychange',
    () => {
      if (enabled && document.visibilityState === 'visible') {
        refetch();
      }
    },
    document,
  );
};
